'use client';
import type { SVGProps } from 'react';
const SvgCheckbox = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.8 12v7.2a.6.6 0 0 1-.6.6H4.8a.6.6 0 0 1-.6-.6V4.8a.6.6 0 0 1 .6-.6h14.4a.6.6 0 0 1 .6.6zm1.2 0V4.8A1.8 1.8 0 0 0 19.2 3H4.8A1.8 1.8 0 0 0 3 4.8v14.4A1.8 1.8 0 0 0 4.8 21h14.4a1.8 1.8 0 0 0 1.8-1.8z"
    />
  </svg>
);
export default SvgCheckbox;
